import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsLessonSongLibraryAction.module.scss";
import {useSongDetailsLessonSongLibraryActionLogic} from "./SongDetailsLessonSongLibraryAction.logic";
import {FavoriteToggle} from "../../../../../../components/songs/favorite-toggle/FavoriteToggle";

export interface ISongDetailsLessonSongLibraryActionProps {
}

export const SongDetailsLessonSongLibraryAction: VoidFunctionComponent<ISongDetailsLessonSongLibraryActionProps> = ({}) => {
  const {buttonLabel, buttonAriaLabel, buttonActionHandler, isButtonDisabled, isFavorited, favoriteActionHandler} = useSongDetailsLessonSongLibraryActionLogic();
  return (
    <div className={s.libraryActionButton}>
      <button
        className={s.libraryToggleButton}
        onClick={buttonActionHandler}
        aria-label={buttonAriaLabel}
        disabled={isButtonDisabled}
      >
        {buttonLabel}
      </button>
      <FavoriteToggle onChangeHandler={favoriteActionHandler} isFavorited={isFavorited} />
    </div>
  );
}

